import Enum from "../../../../../../enums/Enum";

const SmokingFrequencyEnum = new Enum({
    SOCIAL: {name: "Social Smoker"},
    MODERATE: {name: "Moderate Smoker"},
    HEAVY: {name: "Heavy Smoker"}
});

export default SmokingFrequencyEnum;